import React from 'react';
import ReactEcharts from 'echarts-for-react';
import ColorPicker from 'src/components/Colorpicker/index-beta';
import { toast } from 'react-toastify';
import responsive from '../../../Responsive';
import adaptToResponsive from './responsiveAdapter';
import SearchableChart from '../../../Searchable/Echarts/SearchableChart';
import { MOBILE } from '../../../Responsive/responsiveIdentifier';
import { useChartManagement } from 'src/managers/chartManager/stateManagement/management';

class EvolutiveLineChart extends React.Component {
  constructor(props) {
    super(props);
    const { error } = this.props;

    this.configurationError = error;
    this.colorPickerRef = React.createRef();
    this.manager = useChartManagement(this);
  }

  shouldComponentUpdate(nextProps) {
    return this.manager.changesChecker(nextProps);
  }

  onChartReady(echarts) {
    this.echarts = echarts;
  }

  // Caso a api retorne um erro no fetch das configurações de cores, não será possivel abrir
  // o color picker e uma mensagem de erro será apresentada ao usuário.
  onConfigurationError() {
    toast.error(this.configurationError.toString());
  }

  /**
   * atualiza as configuracoes da instancia de echarts
   * passada.
   */
  updateOptions(newOptions) {
    this.setState((prevState) => ({
      ...prevState,
      options: {
        ...prevState.options,
        ...newOptions,
      },
    }));
  }

  render() {
    const { colorPickerColors, resolution, chartRef } = this.props;

    const options = this.manager.getOptions();

    const isMobile = resolution === MOBILE;
    const adaptedOptions = isMobile ? adaptToResponsive(options) : options;

    return (
      <>
        <ReactEcharts
          option={adaptedOptions}
          notMerge
          onChartReady={(echarts) => this.onChartReady(echarts)}
          ref={(echarts) => {
            chartRef.current = echarts;
            this.chartRef = echarts;
          }}
          onEvents={{
            dblclick: (ctx) => this.manager.handleOnDoubleClick(ctx),
            legendselectchanged: (ctx) => this.manager.handleOnLegendChange(ctx),
          }}
        />
        <ColorPicker
          ref={this.colorPickerRef}
          hideColorPicker={() => this.manager.colorPickerHandler.hideColorPicker()}
          changeBarColor={(newColor) => this.manager.colorPickerHandler.changeColorHandler(newColor)}
          colors={colorPickerColors}
        />
      </>
    );
  }
}

export default responsive(EvolutiveLineChart);
